/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Kit 2 React components
import Grid2 from "@mui/material/Unstable_Grid2";

import categoryColor from "utils/categoryColor";
import analysisCollections from "../../../store/constant/analysisCollections";
import MKTypography from "../../../components/MKTypography";
import AnalysisCard from "../../../views/Cards/ImageCard/AnalysisCard";

function Analysis() {
  const categories = [
    "water",
    "ecology",
    // "agriculture"
  ];
  const { collections } = analysisCollections;

  return (
    <Grid2 container xs={12} my={2}>
      {categories.map((category) => (
        <Grid2 container xs={12} key={category}>
          <Grid2 xs={2} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <MKTypography variant="h3" textTransform="capitalize">
              {category}
            </MKTypography>
          </Grid2>
          <Grid2
            container
            xs={10}
            sx={{ borderRadius: "xl", p: 1, borderColor: categoryColor(category).state }}
          >
            {collections
              .filter((a) => a.summaries.info.category === category)
              .map((c) => (
                <Grid2 item key={c.id} xs={3} px={2}>
                  <AnalysisCard image={c.summaries.thumbnail} name={c.title} link={c.id} />
                </Grid2>
              ))}
          </Grid2>
        </Grid2>
      ))}
    </Grid2>
  );
}

export default Analysis;
